import React, { Component } from 'react';
import axios from "axios";
import { connect } from "react-redux";
import { Trans } from 'react-i18next';
import { useMutation } from "@apollo/client";

import { UPDATE_VEHICLE } from "../../../../GraphQL/Mutations/vehicles";
import { LoadingIcon } from '../../../Common/Loading_Icon';
import { setOverlay } from '../../../../Actions/stakeholderActions';
import PopupModal from '../../../Common/DesignSystem/PopupModal';
import colours from '../../../Common/DesignSystem/Colours';
import { P2Bold } from '../../../Common/DesignSystem/Text';
import Button from '../../../Common/DesignSystem/Button';
import { BookingCard, ReminderCard } from '../../../Common/DesignSystem/VehicleResultCard';

const RetireButton = ({ disabled, legacyApiRetireVehicle, currentVehicle, history }) => {
    // const [updateVehicleMutation, { data: updatedVehicle, loading: updateLoading, error: updateError }] = useMutation(UPDATE_VEHICLE);

    // const { sourceVehicleId, id } = currentVehicle;

    const retireVehicleGraphQL = async () => {
        return;

        // Removed to use the new vehicle sync from the Legacy API
        // const vehicle = {
        //     id,
        //     active: false,
        //     terminatedAt: new Date().toISOString()
        // }

        // await updateVehicleMutation({ variables: { input: vehicle } });

        // showStatusMsg('Vehicle has been retired successfully.', 'success');
        // window.location.assign(`/vehicleoverview/vehicle/${sourceVehicleId}/Overview/${id}`);
    }

    const retireVehicle = () => legacyApiRetireVehicle(retireVehicleGraphQL)

    return currentVehicle ? (
        <Button
            label='Retire Vehicle'
            primary
            large
            red
            disabled={disabled}
            onClick={retireVehicle}
            containerProps={{style: {display: 'flex' , flex: 1, maxWidth: '172px'}}}
            style={{flex: 1}}
        />
    ) : <></>
}

class RetireVehicleOverlay extends Component {
    constructor(props) {    
        super(props);

        this.removeAll = this.removeAll.bind(this);
        this.getVehicle = this.getVehicle.bind(this);
        this.retireVehicle = this.retireVehicle.bind(this);
        this.cancelBooking = this.cancelBooking.bind(this);
        this.rejectBooking = this.rejectBooking.bind(this);
        this.cancelReminder = this.cancelReminder.bind(this);
        this.returnBooking = this.returnBooking.bind(this);

        this.state = {
            loaded: false,
            current_bookings: [],
            pending_return_bookings: [],
            upcomming_bookings: [],
            pending_bookings: [],
            reminders: [],
            vehicle: {},
            has_sh_admin: false,
            has_servicing: false
        };
    }

    componentDidMount() {
        var self = this;
        if (this.props.match.params.v_id in this.props.data.vehicle_db) {
            this.setState({
                vehicle: this.props.data.vehicle_db[this.props.match.params.v_id]
            })
        }

        axios.get('/ajax/retirevehicle/' + this.props.match.params.v_id)
        .then(function(response) {
            self.setState({
                vehicle: response?.data.view.vehicle,
                current_bookings: response?.data.view.current,
                pending_return_bookings: response?.data.view.pending_return,
                upcomming_bookings: response?.data.view.upcomming_bookings,
                pending_bookings: response?.data.view.pending_bookings,
                reminders: response?.data.view.reminders,
                has_sh_admin: response?.data.view.has_sh_admin,
                has_servicing: response?.data.view.has_servicing,
                loaded: true
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }

            if (self.props.closeModal) self.props.closeModal();
        })
    }

    removeAll() {
        var self = this;

        if (window.confirm("Are you sure you would like to cancel all bookings and vehicle reminders?")) {
            axios.post('/ajax/retirevehicle/removeall/' + this.props.match.params.v_id)
            .then(function(response) {
                showStatusMsg(response?.data.message, 'success')
                self.setState({
                    upcomming_bookings: [],
                    pending_bookings: [],
                    reminders: [],
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    getVehicle() {
        return axios.get('/ajax/vehicle/' + this.props.match.params.v_id)
            .then((response) => {
                this.props.dispatch(setOverlay("SET_CURRENT_VEHICLE_DETAILS", response?.data))
            })
    }

    retireVehicle(retireVehicleGraphQL) {
        var self = this;

        if (self.state.pending_return_bookings.length === 0 && self.state.upcomming_bookings.length === 0 && self.state.reminders.length === 0 && window.confirm("Are you sure you would like to retire this vehicle?")) {
            axios.post('ajax/retirevehicle/retire/' + self.props.match.params.v_id)
            .then(function(response) {
                // self.getVehicle();

                // Removed to use the new vehicle sync from the Legacy API
                // retireVehicleGraphQL();
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data?.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    cancelBooking(ID) {
        var self = this;
        if (window.confirm("Are you sure you would like to cancel this booking?")) {
            axios.post('/ajax/booking/' + ID + '/delete')
            .then(function(response) {
                for (var i = 0; i < self.state.upcomming_bookings.length; i++) {
                    if (self.state.upcomming_bookings[i].BOOK_ID === ID) {
                        var bookings = self.state.upcomming_bookings
                        bookings.splice(i, 1)

                        self.setState({
                            upcomming_bookings: bookings
                        })
                    }
                }
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    rejectBooking(ID) {
        var self = this;
        if (window.confirm("Are you sure you would like to reject this booking request?")) {
            axios.post('/ajax/booking/' + ID + '/reject/notes', {
                notes: "Retiring Vehicle"
            })
            .then(function(response) {
                for (var i = 0; i < self.state.pending_bookings.length; i++) {
                    if (self.state.pending_bookings[i].BOOK_ID === ID) {
                        var bookings = self.state.pending_bookings
                        bookings.splice(i, 1)

                        self.setState({
                            pending_bookings: bookings
                        })
                    }
                }
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    cancelReminder(ID) {
        var self = this;
        axios.post('/ajax/reminder/' + ID + '/delete')
        .then(function(response) {
            showStatusMsg(response?.data.message, 'success')
            for (var i = 0; i < self.state.reminders.length; i++) {
                if (self.state.reminders[i].REMIND_ID === ID) {
                    var reminders = self.state.reminders
                    reminders.splice(i, 1)

                    self.setState({
                        reminders: reminders
                    })
                }
            }
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    returnBooking(ID) {
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/return/' + ID)
    }

    render(props) {
        return (
            <PopupModal 
                headerIcon="RetireDate" 
                headerIconStyle={{backgroundColor: colours.functional.hover_secondaryred, color: colours.accent.error_red, borderRadius: 16}}
                close={this.props.history.goBack}
                content={
                    <div>
                            <div>
                                {
                                    "Make" in this.state.vehicle ?
                                        this.state.pending_return_bookings.length > 0 ?
                                            <P2Bold><Trans>Cannot Retire </Trans>{this.state.vehicle.Year} {this.state.vehicle.Make} {this.state.vehicle.Model}</P2Bold>
                                        :
                                            <P2Bold><Trans>Are you sure you want to retire</Trans> {this.state.vehicle.Year} {this.state.vehicle.Make} {this.state.vehicle.Model}?</P2Bold>
                                    :
                                        <P2Bold><Trans>Are you sure you want to retire this vehicle</Trans>?</P2Bold>
                                }
                            </div>
                            {
                                this.state.pending_return_bookings.length > 0 ?
                                    <div>
                                        <div className = "card-section">
                                            <p><Trans>You cannot retire this vehicle because it has a current or past booking which has not been checked in. Please try again once it has been checked in.</Trans></p>
                                            <br />
                                            {
                                                !this.state.has_servicing ?
                                                    <p className="black-lighter"><Trans>As a SH user, you are not able to check-in vehicles. Please contact the Vehicle Centre to enquire about the following bookings. You will be able to retire the vehicle only after the following bookings have been checked-in.</Trans></p>
                                                :
                                                    <></>                                                    
                                            }
                                        </div>
                                        <div className = "retire-bookings-section">
                                            {
                                                this.state.pending_return_bookings.map((booking) => {
                                                    return(
                                                        <BookingCard booking={booking} action='return' onAction={() => this.returnBooking(booking.BOOK_ID)}/>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                            :
                                    <div>
                                        {
                                            this.state.loaded ?
                                                <div>
                                                    {
                                                        this.state.upcomming_bookings.length > 0 || this.state.pending_bookings.length > 0 || this.state.reminders.length > 0 ?
                                                            <div>
                                                                <div className = "card-section" style={{borderBottom: 'none'}}>
                                                                    <p><Trans>You cannot retire this vehicle because there are outstanding bookings and/or vehicle reminders. All bookings must be cancelled and all vehicle reminders must be dismissed before the vehicle can be retired.</Trans></p>
                                                                </div>
                                                                <div className = "retire-bookings-section">
                                                                    <div className = "retire-header">
                                                                        <div style={{display: 'flex', flex: 1}}>
                                                                            <P2Bold className = "float-left mt-8"><Trans>Bookings and Vehicle Reminders</Trans></P2Bold>
                                                                        </div>
                                                                        {
                                                                            this.state.has_sh_admin ?
                                                                                <div style={{}}>
                                                                                    <Button 
                                                                                        onClick={this.removeAll} 
                                                                                        label={<Trans>Remove All</Trans>}
                                                                                        secondary
                                                                                        small
                                                                                        red
                                                                                        color={colours.accent.error_red}
                                                                                        leading_ic={'XCircle'}
                                                                                        />
                                                                                </div>
                                                                            :
                                                                                null
                                                                        }
                                                                        <div className = "clearfix"></div>
                                                                    </div>
                                                                    {
                                                                        this.state.upcomming_bookings.map((booking) => {
                                                                            return(
                                                                                <BookingCard booking={booking} action='cancel' onAction={() => this.rejectBooking(booking.BOOK_ID)}/>
                                                                            )
                                                                        })
                                                                    }
                                                                    {
                                                                        this.state.pending_bookings.map((booking) => {
                                                                            return(
                                                                                <BookingCard booking={booking} action='cancel' onAction={()=> this.rejectBooking(booking.BOOK_ID)}/>
                                                                            )
                                                                        })
                                                                    }
                                                                    {
                                                                        this.state.reminders.map((reminder) => {
                                                                            return(
                                                                                <ReminderCard reminder={reminder} action='cancel' onAction={()=> this.cancelReminder(reminder.REMIND_ID)} odometer={this.state.vehicle.Odometer}/>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                                {
                                                                    !this.state.has_sh_admin && (this.state.upcomming_bookings.length > 0 || this.state.pending_bookings.length > 0) ?
                                                                        <p className="black-lighter"><Trans>As a VC user, you are not able to cancel outstanding bookings. Please contact the Stakeholder to enquire about the following bookings. You will be able to retire the vehicle only after the following bookings have been completed or cancelled.</Trans></p>
                                                                    :
                                                                        <p className="black-lighter"><Trans>Retiring a vehicle will not delete any information related to the vehicle such as bookings, vehicle reminders and specifications. All information related to retired vehicles can be viewed in the Retired tab on the Vehicles page.</Trans></p>
                                                                }
                                                            </div>
                                                        :
                                                            <div>
                                                                <br/>
                                                                <p className="black-lighter"><Trans>Retiring a vehicle will not delete any information related to the vehicle such as bookings, vehicle reminders and specifications. All information related to retired vehicles can be viewed in the Retired tab on the Vehicles page.</Trans></p>
                                                            </div>
                                                        }
                                                    <div style={{display: 'flex', flexDirection: 'row', flex: 2, justifyContent: 'center', alignItems: 'center', marginTop: 24}}>
                                                        <Button 
                                                            label='Cancel' 
                                                            secondary 
                                                            large 
                                                            onClick={this.props.history.goBack} 
                                                            containerProps={{style: {display: 'flex' , flex: 1, maxWidth: '172px'}}} 
                                                            style={{flex: 1}}
                                                        />
                                                        <div style={{width: '24px'}}></div>
                                                        <RetireButton
                                                            disabled={(this.state.pending_return_bookings.length + this.state.upcomming_bookings.length + this.state.pending_bookings.length + this.state.reminders.length) > 0}
                                                            legacyApiRetireVehicle={this.retireVehicle}
                                                            currentVehicle={this.props.stakeholder.current_vehicle}
                                                            history={this.props.history}
                                                        />
                                                    </div>
                                                </div>
                                            :
                                                <LoadingIcon />
                                        }
                                    </div>
                            }
                    </div>
                }
            />
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(RetireVehicleOverlay)